import { Box, Button, Container, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { StyledPaper } from "../component/shared/StyledComponents";
import { useAuth } from "../context/AuthProvider";
import { useMenu } from "../context/MenuProvider";
import KarvesProduktyvumui from "../component/BandosProduktyvumas/KarvesProduktyvumui";
import { useEffect, useMemo, useRef, useState } from "react";
import StrukturosPasirinkimai from "../component/BandosStruktura/StrukturosPasirinkimai";
import { kontrolesPeriodai } from "../constants/KontrolesPeriodai";
import { FlexColumnBox } from "../component/shared/GrupiuSelectuList";
import GrupiuSelectItem from "../component/shared/GrupiuSelectItem";
import { LaktacijuAmziai } from "../constants/ParametruGrupes";
import DvigubaSlankjuoste from "../component/BandosProduktyvumas/DvigubaSlankjuoste";
import {
  LaktacijosTrukmeDienomisIlgesnis,
  LaktacijosTrukmeDienomisMazesneDaugiauDieniu,
} from "../constants/SlankjuostesZingniai";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getItem, postItem, postTestItem } from "../Api/Api";
import { urlSuParametrais } from "../functions/urlSuParametrais";
import axios from "axios";
import KarviuProduktyvumoLentele from "../component/BandosProduktyvumas/KarviuProduktyvumoLentele";
import { karviuRodikliuStulpeliai } from "../constants/LenteliuStulpeliai";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ProdGrafikas from "../component/home/ProdGrafikas";
import { Rodikliai } from "../constants/Rodikliai";
import { filterLaktacijosZymes } from "../functions/laktacijosZymes";
import GrafikaiSuRibomis from "../component/KarvesIstoriniaiRodikliai/GrafikaiSuRibomis";
import Switch from "@mui/material/Switch";
// FIXME: grafikas per daug daznai atsinaujina kazka paspaudus. prideti setTimeout, kad atsinaujintu biski reciau, o ne su kiekvienu pirstelejimu.
// [x]: atidarius puslapi, yra issiunciamas requestas, ir is karto atsaukiamas, tada vel iskarto siunciamas antras, ir kol antras yra gaunamas,
//      del pirmo yra rodomas klaidos pranesimas, kad duomenu nera
const KarvesRodikliai = () => {
  const auth = useAuth();
  const menu = useMenu();
  const savininkas = menu.savininkas;
  const arSavininkas = auth.user.role === "Ūkis";
  const [searchParameters] = useSearchParams();

  const bandaParam = searchParameters.get("b");
  const karveParam = searchParameters.get("k");
  searchParameters.delete("b");
  searchParameters.delete("k");

  const [duomenys, setDuomenys] = useState([]);
  const [klaida, setKlaida] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [bandos, setBandos] = useState(0);
  const [veisles, setVeisles] = useState(0);
  const [menesis, setMenesis] = useState(kontrolesPeriodai[0]);
  const [laktacijos, setLaktacijos] = useState(LaktacijuAmziai.map((g) => g.id));
  const [laktacijosReziai, setLaktacijosReziai] = useState([0, 2000]);
  const [karves, setKarves] = useState([]);
  const [originalusKarviuSkaicius, setOriginalusKarviuSkaicius] = useState([]);
  const [rodiklis, setRodiklis] = useState(Rodikliai[0]);
  const [oneCowIsSelected, setOneCowIsSelected] = useState(false);
  const [pasirinktaKarve, setPasirinktaKarve] = useState(null);
  const [rodytiZvaizdutesAnimacija, setRodytiZvaizdutesAnimacija] = useState(false);
  const [rodytiEtiketes, setRodytiEtiketes] = useState(true);
  const [rodytiZvaigzdute, setRodytiZvaigzdute] = useState(false);
  const ribuGrafikoDydziai = 310;
  const ribuGrafikoGridDydziai = 360;
  let trukmesDuomenys = [];

  const handleStarSwitchChange = () => {
    setRodytiZvaizdutesAnimacija((prev) => !prev);
  };

  const handleLabelSwitchChange = () => {
    setRodytiEtiketes((prev) => !prev);
  };

  const handleStarShowSwitchChange = () => {
    setRodytiZvaigzdute((prev) => !prev);
  };

  const starSwitchLabel = { inputProps: { "aria-label": "ZvaigzdutesAnimacija" } };
  const labelSwtchLabel = { inputProps: { "aria-label": "etiketes" } };
  const starShowSwitchLabel = { inputProps: { "aria-label": "Zvaigzdute" } };

  const location = useLocation();
  const isInitializedRef = useRef(false);
  const cancelSourceRef = useRef();
  const navigate = useNavigate();

  const prevKarvesRef = useRef(karves);
  const prevOriginalusKarviuSkaiciusRef = useRef(originalusKarviuSkaicius);
  const prevFiltersRef = useRef({
    bandos: 0,
    veisles: 0,
    laktacijosZymes: [],
    laktacijosReziai: [0, 2000],
    savininkas: null,
    arSavininkas: null,
  });
  const hasInitialFetchOccurred = useRef(false);

  useEffect(() => {
    const params = [
      { parameter: arSavininkas, condition: "false", append: "savininkas", value: menu.savininkas },
    ];

    getItem(urlSuParametrais("bandos/dydis", params))
      .then((data) => {
        data.data && setOriginalusKarviuSkaicius(data.data);
      })
      .catch((error) => {
        if (error.response) {
          const status = error.response.status;
          const errorMessage = error.response.data?.error || error.response.data?.message;
          if (status === 404) {
            setKlaida(errorMessage);
            setOriginalusKarviuSkaicius([]);
          }
          if (status === 401) navigate("/login");
          else {
            setKlaida("Įvyko klaida. Bandykite dar kartą.");
          }
        }
      });
  }, [savininkas, arSavininkas]);

  const laktacijosZymes = useMemo(() => {
    return filterLaktacijosZymes(laktacijos);
  }, [laktacijos]);

  const handleChangeKarve = (checked, value) => {
    if (checked) {
      if (value !== undefined) {
        setKarves([...karves, value]);
      }
    } else {
      if (value !== undefined) {
        setKarves(karves.filter((k) => k !== value));
      }
    }
  };

  const saveCurrentStateAndGoHome = () => {
    const currentFilters = {
      bandos,
      veisles,
      menesis,
      laktacijos,
      laktacijosReziai,
      karves,
    };

    localStorage.setItem("rodikliaiFilters", JSON.stringify(currentFilters));

    auth.changeScreen("/");
    navigate("/");
  };

  const handleChangeKarvesVisos = (arr) => {
    setKarves(arr);
  };

  useEffect(() => {
    setBandos(0);
    setVeisles(0);
    setKarves([]);
    setLaktacijos(LaktacijuAmziai.map((g) => g.id));
    setOriginalusKarviuSkaicius([]);
    setDuomenys([]);
    trukmesDuomenys = [];
    setMenesis(kontrolesPeriodai[0]);
    setLaktacijosReziai(() => [0, 2000]);

    // Reset selected cow when owner changes
    setPasirinktaKarve(null);
    setOneCowIsSelected(false);

    isInitializedRef.current = false;

    setTimeout(() => {
      isInitializedRef.current = true;
    }, 100);
  }, [arSavininkas, savininkas]);

  useEffect(() => {
    if (!isInitializedRef.current) {
      return;
    }

    // Check if only cow selection changed (and no other filters)
    const currentFilters = {
      bandos,
      veisles,
      laktacijosZymes: JSON.stringify(laktacijosZymes),
      laktacijosReziai: JSON.stringify(laktacijosReziai),
      savininkas,
      arSavininkas,
    };

    const prevFilters = prevFiltersRef.current;
    const filtersChanged =
      currentFilters.bandos !== prevFilters.bandos ||
      currentFilters.veisles !== prevFilters.veisles ||
      currentFilters.laktacijosZymes !== prevFilters.laktacijosZymes ||
      currentFilters.laktacijosReziai !== prevFilters.laktacijosReziai ||
      currentFilters.savininkas !== prevFilters.savininkas ||
      currentFilters.arSavininkas !== prevFilters.arSavininkas;

    // Calculate cow counts for comparison
    const prevTotalCowCount = Array.isArray(prevOriginalusKarviuSkaiciusRef.current)
      ? prevOriginalusKarviuSkaiciusRef.current.reduce((total, herd) => total + herd.dydis, 0)
      : 0;
    const currentTotalCowCount = Array.isArray(originalusKarviuSkaicius)
      ? originalusKarviuSkaicius.reduce((total, herd) => total + herd.dydis, 0)
      : 0;
    const currentSelectedHerdCowCount =
      bandos !== 0 && Array.isArray(originalusKarviuSkaicius)
        ? originalusKarviuSkaicius.find((herd) => herd.banda === bandos)?.dydis || 0
        : currentTotalCowCount;

    // Check if current and previous states are "all cows selected"
    const prevWasAllCows =
      prevKarvesRef.current.length === 0 ||
      (prevTotalCowCount > 0 && prevKarvesRef.current.length === prevTotalCowCount);

    const currentIsAllCows =
      karves.length === 0 ||
      (currentTotalCowCount > 0 &&
        (karves.length === currentSelectedHerdCowCount || karves.length === currentTotalCowCount));

    // Only skip if it's just a cow selection transition between "all" states AND no other filters changed
    if (prevWasAllCows && currentIsAllCows && !filtersChanged && hasInitialFetchOccurred.current) {
      // Update refs for next comparison
      prevKarvesRef.current = karves;
      prevOriginalusKarviuSkaiciusRef.current = originalusKarviuSkaicius;
      return;
    }

    // Add a small delay to prevent rapid-fire requests
    const timeoutId = setTimeout(() => {
      // Cancel any pending request
      if (cancelSourceRef.current) {
        cancelSourceRef.current.cancel("Canceled due to new request");
      }

      cancelSourceRef.current = axios.CancelToken.source();
      setIsLoading(true);
      setKlaida(""); // Clear any previous errors

      const params = [
        {
          parameter: arSavininkas,
          condition: "false",
          append: "savininkas",
          value: menu.savininkas,
        },
        { parameter: bandos, condition: "!==0", append: "banda", value: bandos },
        { parameter: veisles, condition: "!==0", append: "veisle", value: veisles },
        {
          parameter: laktacijosReziai,
          condition: "more than 0",
          append: "trukme_nuo",
          value: laktacijosReziai[0],
        },
        {
          parameter: laktacijosReziai,
          condition: "less than 2000",
          append: "trukme_iki",
          value: laktacijosReziai[1],
        },
      ];

      // Only include karves in API call when it's a partial selection
      const shouldIncludeKarves =
        karves.length > 0 &&
        Array.isArray(originalusKarviuSkaicius) &&
        originalusKarviuSkaicius.length > 0;

      let requestBody = {
        amziusLaktacijoms:
          laktacijosZymes.length > 0 && laktacijosZymes.length < 5 ? laktacijosZymes : [],
        karves: shouldIncludeKarves ? karves : [],
      };

      postItem(
        urlSuParametrais("karves/rodikliai", params),
        requestBody,
        cancelSourceRef.current.token
      )
        .then((data) => {
          if (data.data) {
            setDuomenys(data.data);
            setKlaida("");
          }
          setIsLoading(false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }

          console.error("API Error:", error);

          if (error.response) {
            const status = error.response.status;
            const errorMessage = error.response.data?.error || error.response.data?.message;

            if (status === 404) {
              setKlaida(errorMessage || "Duomenų nerasta");
              setDuomenys([]);
            } else if (status === 401) {
              navigate("/login");
            } else if (status === 500) {
              setKlaida("Serverio klaida. Patikrinkite parametrus ir bandykite dar kartą.");
            } else {
              setKlaida("Įvyko klaida. Bandykite dar kartą.");
            }
          } else {
            setKlaida("Nepavyko prisijungti prie serverio.");
          }

          setIsLoading(false);
        })
        .finally(() => {
          hasInitialFetchOccurred.current = true;
        });
    }, 300); // 300ms delay to prevent rapid requests

    return () => clearTimeout(timeoutId);
  }, [
    bandaParam,
    karveParam,
    karves,
    savininkas,
    menu.savininkas,
    laktacijosZymes,
    veisles,
    bandos,
    laktacijosReziai,
    originalusKarviuSkaicius,
    isInitializedRef.current,
  ]); // [x]: Add all dependencies and local storage

  useEffect(() => {
    hasInitialFetchOccurred.current = false;
  }, [arSavininkas, savininkas]);

  useEffect(() => {
    if (karveParam && !pasirinktaKarve) {
      setPasirinktaKarve(karveParam);
    }
  }, [karveParam, pasirinktaKarve]);

  const processedDuomenys = useMemo(() => {
    if (!duomenys || !Array.isArray(duomenys) || duomenys.length === 0) {
      return [];
    }

    const flattenedData = [];

    duomenys.forEach((cow) => {
      const laktacijosData = [];

      if (cow.laktacijos && Array.isArray(cow.laktacijos) && cow.laktacijos.length > 0) {
        cow.laktacijos.forEach((lactationData) => {
          laktacijosData.push({
            nr: lactationData.nr,
            pienas_kg: lactationData.p_kg,
            rb_kg: lactationData.rb_kg,
          });
        });
      }

      flattenedData.push({
        isHeader: true,
        karve: cow.k_nr,
        veisle: cow.veisle,
        banda: cow.banda,
        lak_duom: laktacijosData,
        reikiaLaktacijuDuomenys: true,
      });

      if (cow.duom && Array.isArray(cow.duom) && cow.duom.length > 0) {
        cow.duom.forEach((monthData) => {
          flattenedData.push({
            isHeader: false,
            karve: cow.k_nr,
            veisle: cow.veisle,
            banda: cow.banda,
            laktAmzius: cow.lakt_amzius,
            menesis: monthData.menuo,
            kontroline_data: monthData.data,
            bukle: monthData.bukle,
            // problemos: monthData.prob,
            nr: monthData.nr,
            l_gr:
              monthData.l_gr === 4
                ? "4-5"
                : monthData.l_gr === 5
                ? "5+"
                : monthData.l_gr != null
                ? String(monthData.l_gr)
                : "",
            trukme: monthData.trukme,
            pienas: monthData.p_ein,
            visasPienasVid: monthData.p_buv,
            bazinis: monthData.bazinis,
            rieb: monthData.r,
            balt: monthData.b,
            lak: monthData.lak,
            urea: monthData.urea,
            sls: monthData.sls,
            sls200k: monthData.sls200,
            sls400k: monthData.sls400,
            seklinimai: monthData.sekl_sk,
            servis: monthData.serv,
            apsiv_inter: monthData.apsiv_d,
            uztruk_dienos: monthData.uztruk_d,
            versingu_inter: monthData.vers_d,
            primilzis: monthData.p_d,
            rb: monthData.rb,
          });
        });
      }
    });

    return flattenedData;
  }, [duomenys]);

  // Add this separate useEffect to handle auto-selection logic
  useEffect(() => {
    if (!processedDuomenys || processedDuomenys.length === 0) {
      setOneCowIsSelected(false);
      return;
    }

    // Get unique cows from the processed data
    const uniqueCows = [
      ...new Set(processedDuomenys.filter((item) => item.isHeader).map((item) => item.karve)),
    ];

    if (uniqueCows.length === 0) {
      setOneCowIsSelected(false);
      return;
    }

    // Check if we should auto-select a cow
    const shouldSelectOneCow = uniqueCows.length === 1 || (karveParam && uniqueCows.length > 0);

    setOneCowIsSelected(shouldSelectOneCow);

    // Auto-select logic
    if (karveParam && uniqueCows.includes(karveParam)) {
      // If there's a karveParam and it exists in our data, select it
      if (pasirinktaKarve !== karveParam) {
        setPasirinktaKarve(karveParam);
      }
    } else if (uniqueCows.length === 1) {
      // If there's only one cow, auto-select it
      if (pasirinktaKarve !== uniqueCows[0]) {
        setPasirinktaKarve(uniqueCows[0]);
      }
    } else if (!pasirinktaKarve && uniqueCows.length > 1) {
      // NEW: If no cow is selected and there are multiple cows, select the first one
      setPasirinktaKarve(uniqueCows[0]);
      setOneCowIsSelected(false); // Don't set oneCowIsSelected to true for multiple cows
    }
  }, [processedDuomenys, karveParam, pasirinktaKarve]);

  trukmesDuomenys = useMemo(() => {
    const dataRows = processedDuomenys.filter((item) => item.isHeader === false);

    if (!dataRows || dataRows.length === 0) return [];

    return dataRows
      .filter(
        (f_item) =>
          f_item.bazinis !== null &&
          f_item.bazinis !== "" &&
          f_item.bazinis !== 0 &&
          f_item.rieb !== null &&
          f_item.rieb !== "" &&
          f_item.rieb !== 0 &&
          f_item.balt !== null &&
          f_item.balt !== "" &&
          f_item.balt !== 0 &&
          f_item.lak !== null &&
          f_item.lak !== "" &&
          f_item.lak !== 0 &&
          f_item.urea !== null &&
          f_item.urea !== "" &&
          f_item.urea !== 0 &&
          f_item.sls !== null &&
          f_item.sls !== "" &&
          f_item.sls !== 0 &&
          f_item.rb !== null &&
          f_item.rb !== "" &&
          f_item.rb !== 0 &&
          f_item.trukme !== null &&
          f_item.trukme !== "" &&
          f_item.trukme !== 0 &&
          f_item.laktAmzius !== null &&
          f_item.laktAmzius !== "" &&
          f_item.primilzis !== null &&
          f_item.primilzis !== "" &&
          f_item.primilzis !== 0 &&
          f_item.karve !== null &&
          f_item.karve !== ""
      )
      .map((item) => ({
        karNr: item.karve || "",
        banda: bandaParam || "",
        veisle: item.veisle || "",
        bazinis: item.bazinis || 0,
        riebalai: item.rieb || 0,
        baltymai: item.balt || 0,
        laktoze: item.lak || 0,
        urea: item.urea || 0,
        sls: item.sls || 0,
        rb: item.rb || 0,
        trukme: item.trukme || 0,
        laktDiena: item.trukme || 0,
        menuo: item.menesis || "",
        laktAmzius: item.l_gr || "",
        laktNr: item.nr || "",
        primilzis: item.primilzis || 0,
        kontrData: item.kontroline_data || "",
      }));
  }, [processedDuomenys, bandaParam]);

  const [rodikliaiGrafikams, setRodikliaiGrafikams] = useState([]);

  const getPasirinktaKarvesInfo = useMemo(() => {
    if (!pasirinktaKarve || !processedDuomenys.length) return null;

    const headerRow = processedDuomenys.find(
      (row) => row.isHeader && row.karve === pasirinktaKarve
    );

    if (!headerRow) return null;

    const cowDataRows = processedDuomenys
      .filter(
        (row) =>
          !row.isHeader &&
          row.karve === pasirinktaKarve &&
          row.visasPienasVid !== null &&
          row.visasPienasVid !== undefined
      )
      .sort((a, b) => {
        // Sort by control date (kontroline_data) to get chronological order
        const dateA = new Date(a.kontroline_data);
        const dateB = new Date(b.kontroline_data);
        return dateB - dateA; // Descending order (latest first)
      });

    const latestMilkData = cowDataRows[0];

    return {
      karve: headerRow.karve,
      banda: headerRow.banda,
      veisle: headerRow.veisle,
      vidPienas: latestMilkData?.visasPienasVid || "Nežinoma",
    };
  }, [pasirinktaKarve, processedDuomenys]);

  useEffect(() => {
    const hasSelectedCow = oneCowIsSelected || pasirinktaKarve !== null;

    if (hasSelectedCow) {
      const targetCowId =
        pasirinktaKarve ||
        (oneCowIsSelected ? processedDuomenys.find((item) => item.isHeader)?.karve : null);

      if (targetCowId) {
        setRodikliaiGrafikams(() => {
          const filteredData = processedDuomenys
            .filter(
              (item) =>
                !item.isHeader &&
                item.menesis &&
                item.karve === targetCowId &&
                (item.pienas !== null || item.visasPienasVid !== null)
            )
            .map((item) => ({
              Mėnesis: item.menesis,
              "Pienas (kg)": item.pienas || 0,
              "Pieno vid. (kg)": item.visasPienasVid,
              "Pienas (kg) bazinis": item.bazinis,
              "Pienas (kg) faktinis": item.primilzis,
              "R (%)": item.rieb,
              "B (%)": item.balt,
              "R/B": item.rb,
              SLS: item.sls,
              "L (%)": item.lak,
              "U mg%": item.urea,
            }));

          return filteredData;
        });
      }
    } else {
      setRodikliaiGrafikams([]);
    }
  }, [oneCowIsSelected, processedDuomenys, pasirinktaKarve]);

  // Add this useEffect after your existing useEffect hooks
  useEffect(() => {
    // When pasirinktaKarve changes, we don't need to do anything special
    // as the table will automatically highlight the correct row based on selectedCowId
    // which is managed by the table component itself
  }, [pasirinktaKarve]);

  return (
    <Container maxWidth="100vw" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h4" sx={{ marginBottom: "20px" }}>
          Karvės istoriniai rodikliai
        </Typography>
        {localStorage.getItem("buvesPuslapis") === "/" &&
          location.pathname === "/karves-rodikliai" && (
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={saveCurrentStateAndGoHome}
              sx={{ marginBottom: "20px" }}
            >
              Grįžti į laktacijos rodiklių puslapį
            </Button>
          )}
      </Box>
      <Grid key="main" container spacing={2} size={12}>
        <Grid
          key="pasirinkimai"
          container
          spacing={2}
          size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        >
          <Grid key="pasirinkimai-be-karviu" container spacing={2} sx={{ width: "100%" }}>
            <Grid key="dropDown-pasirinkimai-paper" container spacing={2} size={12}>
              <StyledPaper
                row="true"
                sx={{
                  gap: "30px",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "auto",
                  width: "100%",
                  flexGrow: 1,
                }}
              >
                <Grid container spacing={2} key="dropDown-pasirinkimai" size={12}>
                  <Grid key="banda" size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                    <StrukturosPasirinkimai
                      banda={bandos}
                      setBanda={setBandos}
                      visosBandos={false}
                    />
                  </Grid>
                  <Grid key="laikas" size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                    <StrukturosPasirinkimai menesis={menesis} setMenesis={setMenesis} />
                  </Grid>
                  <Grid key="amzius" size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                    <FlexColumnBox>
                      <GrupiuSelectItem
                        pavadinimas={"Amžius laktacijomis"}
                        grupes={LaktacijuAmziai}
                        pasirinktos={laktacijos}
                        changeGrupes={setLaktacijos}
                        fullWidth
                        tekstas="Pasirinkta"
                      />
                    </FlexColumnBox>
                  </Grid>
                  <Grid key="veisle" size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}>
                    <StrukturosPasirinkimai veisle={veisles} setVeisle={setVeisles} />
                  </Grid>
                </Grid>
              </StyledPaper>
            </Grid>
          </Grid>
          <Grid key="slider-per_visa-ekrana" container spacing={2} sx={{ width: "100%" }}>
            <StyledPaper
              sx={{
                width: "100%",
              }}
            >
              <DvigubaSlankjuoste
                key={`${arSavininkas}-${savininkas}`}
                min={0}
                max={2000}
                zingsnis={10}
                label="Minimum distance"
                numatytoji={laktacijosReziai}
                marksBigScreen={LaktacijosTrukmeDienomisIlgesnis}
                marksSmallScreen={LaktacijosTrukmeDienomisMazesneDaugiauDieniu}
                changeValue={setLaktacijosReziai}
                pavadinimas="Laktacijos trukmė dienomis, nuo – iki"
                disableSwap
                minSkirtumas={31}
                toolTipPaaiskinimas="Šis pasirinkimas bus naudojamas filtruojant buvusių laktacijų duomenis pagal jų trukmę, Einamajai laktacijai šis pasirinkimas neturi įtakos."
              />
            </StyledPaper>
          </Grid>
          <Grid key="pasirinkimai-karviu" size={{ xs: 12, md: 4, lg: 4, xl: 2 }}>
            <StyledPaper
              sx={{
                height: "100%",
                minHeight: "620px",
                maxHeight: "650px",
                overflow: "hidden",
                zIndex: 1000,
              }}
            >
              <KarvesProduktyvumui
                savId={savininkas}
                bandos={bandos === 0 ? [] : [bandos]}
                karves={karves}
                changeKarves={handleChangeKarve}
                handleZymVisasKarves={handleChangeKarvesVisos}
                papildomaInfo
                veisles={veisles === 0 ? [] : [veisles]}
                dynamicSize
                laktacijos={laktacijosZymes}
                stickyHeader
              />
            </StyledPaper>
          </Grid>
          <Grid key="scatter-diagrama" size={{ xs: 12, md: 8, lg: 8, xl: 10 }}>
            <StyledPaper
              sx={{
                gap: "30px",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
              }}
            >
              {/* [x] padaryti, kad butu galima paspausti ant karves ir rodytu jos duomenis grafikuose?
                  [x] geresnis pasirinkto menesio paryskinimas
                  [x] spalvinimas su animation sukuria nauja taskiuka, kurio nereiketu.*/}
              <ProdGrafikas
                isLoading={isLoading}
                duomenys={trukmesDuomenys}
                rodiklis={rodiklis}
                rodikliai={Rodikliai}
                setRodiklis={setRodiklis}
                pasirinktasMenesis={menesis}
                grupuotiPagal="laktAmzius"
                reikiaLaktacijosAmziaus
                reikiaExcelFailo={false}
                setPasirinktaKarve={setPasirinktaKarve}
                paspaudziamaKarveRodikliams
                pasirinktaKarve={pasirinktaKarve}
                karvesPaspaudimoPaaiskinimas="Paspauskite ant karvės, kad pamatytumėte jos rodiklius grafike."
                rodytiZvaizdutesAnimacija={rodytiZvaizdutesAnimacija}
                rodytiEtiketes={rodytiEtiketes}
                rodytiZvaigzdute={rodytiZvaigzdute}
              />
            </StyledPaper>
          </Grid>
        </Grid>
        {/* [x] kuomet ateinama is home puslapio paspaudus ant karves, tai tuomet ta karve pazymi kaip pasirinkta */}
        <Grid key="karviu-rodikliai" container spacing={2} size={12}>
          <Grid
            key="pasirinkta-karve-paper"
            size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
            sx={{ width: "100%" }}
          >
            <StyledPaper>
              <Grid
                key="pasirinkta-karve-info"
                container
                spacing={2}
                size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
              >
                {getPasirinktaKarvesInfo && rodikliaiGrafikams.length !== 0 ? (
                  <>
                    <Grid key="karves-numeris" size={{ xs: 12, md: 6, lg: 3, xl: 3 }}>
                      <Typography>
                        Karvė:<strong> {getPasirinktaKarvesInfo.karve}</strong>
                      </Typography>
                    </Grid>
                    <Grid key="karves-banda" size={{ xs: 12, md: 6, lg: 3, xl: 3 }}>
                      <Typography>
                        Banda:<strong> {getPasirinktaKarvesInfo.banda}</strong>
                      </Typography>
                    </Grid>
                    <Grid key="karves-veisle" size={{ xs: 12, md: 6, lg: 3, xl: 3 }}>
                      <Typography>
                        Veislė:<strong> {getPasirinktaKarvesInfo.veisle || "Nenurodyta"}</strong>
                      </Typography>
                    </Grid>
                    <Grid
                      key="karves-einamosios-laktacijos-duomenys"
                      size={{ xs: 12, md: 6, lg: 3, xl: 3 }}
                      gap={{ xl: 2 }}
                    >
                      <Typography>
                        Vid. pienas per laktacijas:
                        <strong> {getPasirinktaKarvesInfo.vidPienas} kg</strong>
                      </Typography>
                    </Grid>
                    <Grid key="switch-konteineris" container size={12} spacing={2}>
                      <Grid key="karves-zaigzdes-animacija" size={{ xs: 12, md: 5, lg: 5, xl: 5 }}>
                        <Tooltip
                          title="Ši parinktis įjungia animaciją, kuri dar labiau paryškina pasirinktą karvę grafike.
                        Animacija matoma jei yra įjungtas ir karvės paryškinimas grafike."
                        >
                          <Typography>
                            <Switch
                              checked={rodytiZvaizdutesAnimacija}
                              onChange={handleStarSwitchChange}
                              {...starSwitchLabel}
                            />
                            {rodytiZvaizdutesAnimacija ? "Išjungti" : "Įjungti"} pasirinktos karvės
                            paryškinimo animaciją
                          </Typography>
                        </Tooltip>
                      </Grid>
                      <Grid key="karves-etikete" size={{ xs: 12, md: 4, lg: 4, xl: 4 }}>
                        <Typography>
                          <Switch
                            checked={rodytiEtiketes}
                            onChange={handleLabelSwitchChange}
                            {...labelSwtchLabel}
                          />
                          {rodytiEtiketes ? "Nerodyti" : "Rodyti"} pasirinktos karvės etiketes
                        </Typography>
                      </Grid>
                      <Grid key="karves-zvaigzdes-rodymas" size={{ xs: 12, md: 3, lg: 3, xl: 3 }}>
                        <Typography>
                          <Switch
                            checked={rodytiZvaigzdute}
                            onChange={handleStarShowSwitchChange}
                            {...starShowSwitchLabel}
                          />
                          {rodytiZvaigzdute ? "Nerodyti paryškinimo" : "Rodyti paryškinimą"} karvei
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid key="extra-paaiskinimas" size={12}>
                      <Typography sx={{ textAlign: "center" }}>
                        Žemiau esančiuose grafikuose yra pateikiama pasirinktos karvės rodikliai.
                      </Typography>
                    </Grid>
                  </>
                ) : (
                  <Grid size={{ xs: 12 }}>
                    <Typography>
                      Pasirinkite karvę lentelėje arba grafike, kad būtų rodomi jos rodikliai
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </StyledPaper>
          </Grid>
          {rodikliaiGrafikams.length !== 0 && (
            // [x]: reikia bazinio ir paprasto pieno grafiku. taip pat reikia ir vid vis lak. ir einamosios laktacijos duomeny lenteliu
            // [x]/[TASKS]:
            // [x] PADARyti maza(?) grid langeli, kuriame butu rasoma pasirinktos karves informcija.
            // [x] Sujungti su nera duomenu langeliu, kad nesikartotu.
            // [x] pasirinkus visas >2 karves reikia padaryti, kad neberodytu karviu grafiku.
            // [x] nzn, bet galbut reiktu kazkokiu metu triinti pasirinkta karve, nes ji per daug ilgai buna pasirinkta, tai cia toks labiau BUG/FEATURE.
            <Grid
              key="karviu-rodikliu-grafikai"
              container
              spacing={2}
              size={{ xs: 12, md: 12, lg: 12, xl: 12 }}
            >
              <Grid
                key="pienas-einamoji-grid"
                size={{ xs: 12, md: 6, lg: 4, xl: 4 }}
                sx={{ width: "100%" }}
              >
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="Pienas (kg)"
                      apatinisRezis={null}
                      virsutinisRezis={null}
                      raktas="Mėnesis"
                      id="pienasEinamojiGrafikas"
                      pavadinimas="Einamosios laktacijos pieno produktyvumas (kg)"
                      minRiba={null}
                      etiketeIki="isXl"
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid
                key="bazinis-pienas-grid"
                size={{ xs: 12, md: 6, lg: 4, xl: 4 }}
                sx={{ width: "100%" }}
              >
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="Pienas (kg) bazinis"
                      apatinisRezis={10}
                      virsutinisRezis={null}
                      raktas="Mėnesis"
                      id="bazinisPienas"
                      pavadinimas="Bazinis pieno primilžis (kg)"
                      minRiba={0}
                      etiketeIki="isLg"
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid
                key="faktinis-pienas-grid"
                size={{ xs: 12, md: 6, lg: 4, xl: 4 }}
                sx={{ width: "100%" }}
              >
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="Pienas (kg) faktinis"
                      apatinisRezis={10}
                      virsutinisRezis={null}
                      raktas="Mėnesis"
                      id="grynasPienas"
                      pavadinimas="Faktinis pieno primilžis (kg)"
                      minRiba={0}
                      etiketeIki="isLg"
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid key="rieb-grid" size={{ xs: 12, md: 6, lg: 4, xl: 4 }} sx={{ width: "100%" }}>
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="R (%)"
                      apatinisRezis={3.4}
                      virsutinisRezis={null}
                      raktas="Mėnesis"
                      id="rProc"
                      pavadinimas="Riebalai (%)"
                      minRiba={0}
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid key="balt-grid" size={{ xs: 12, md: 6, lg: 4, xl: 4 }} sx={{ width: "100%" }}>
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="B (%)"
                      apatinisRezis={3}
                      virsutinisRezis={null}
                      raktas="Mėnesis"
                      id="bProc"
                      pavadinimas="Baltymai (%)"
                      minRiba={0}
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid key="rb-grid" size={{ xs: 12, md: 6, lg: 4, xl: 4 }} sx={{ width: "100%" }}>
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="R/B"
                      apatinisRezis={1}
                      virsutinisRezis={1.4}
                      raktas="Mėnesis"
                      id="rb"
                      pavadinimas="Riebalų ir baltymų santykis R/B"
                      minRiba={0}
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid
                key="somLast-grid"
                size={{ xs: 12, md: 6, lg: 4, xl: 4 }}
                sx={{ width: "100%" }}
              >
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="SLS"
                      apatinisRezis={null}
                      virsutinisRezis={400}
                      raktas="Mėnesis"
                      id="sls"
                      pavadinimas="Somatinės ląstelės (tūkst./ml)"
                      minRiba={0}
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid
                key="laktoze-grid"
                size={{ xs: 12, md: 6, lg: 4, xl: 4 }}
                sx={{ width: "100%" }}
              >
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="L (%)"
                      apatinisRezis={4}
                      virsutinisRezis={null}
                      raktas="Mėnesis"
                      id="lak"
                      pavadinimas="Laktozė (%)"
                      minRiba={0}
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
              <Grid key="ureja-grid" size={{ xs: 12, md: 6, lg: 4, xl: 4 }} sx={{ width: "100%" }}>
                <StyledPaper
                  sx={{
                    gap: "30px",
                    justifyContent: "center",
                    alignItems: "stretch",
                    margin: "auto",
                    width: "100%",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box sx={{ width: "100%", height: ribuGrafikoGridDydziai }}>
                    <GrafikaiSuRibomis
                      duomenys={rodikliaiGrafikams}
                      rodiklis="U mg%"
                      apatinisRezis={15}
                      virsutinisRezis={30}
                      raktas="Mėnesis"
                      id="urea"
                      pavadinimas="Urėja (mg%)"
                      minRiba={0}
                      height={ribuGrafikoDydziai}
                    />
                  </Box>
                </StyledPaper>
              </Grid>
            </Grid>
          )}
          <Grid
            key="karviu-rodikliu-lentele"
            size={{
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            }}
          >
            <StyledPaper
              sx={{
                gap: "30px",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
              }}
            >
              <KarviuProduktyvumoLentele
                pavadinimas="Karvės istoriniai rodikliai"
                isLoading={isLoading}
                duomenys={processedDuomenys}
                stulpeliai={karviuRodikliuStulpeliai}
                aukstis={650}
                savininkas={menu.savininkas}
                arSavininkas={arSavininkas}
                banda={bandos}
                rodikliuPaaiskinimas
                rodikliuAtsisiuntimoTekstas="Atsisiųsti karvės rodiklius"
                laktacijuAtsisiuntimoTekstas="Atsisiųsti laktacijų rodiklius"
                setPasirinktaKarve={setPasirinktaKarve}
                selectedCowId={pasirinktaKarve}
                mainBoxPadding={{ xs: "125px", sm: "75px", md: "30px", lg: "30px", xl: "30px" }}
                enableStickyHeader={true}
              />
            </StyledPaper>
          </Grid>
        </Grid>

        {/* [x] grafika rodyti tik vienai karvei:
  [x] kai viena karve pasirinkta, tai ir jos rodyti duomenis
  kai pasirinktos visos karves, tai prie karviu rodyti pasirinkti mygtuka, kuri paspausdus bus rodomas pasirinktos karves duomenys   */}
      </Grid>
    </Container>
  );
};
export default KarvesRodikliai;
